import { render, staticRenderFns } from "./sysRegister.vue?vue&type=template&id=06cd1063&"
import script from "./sysRegister.vue?vue&type=script&lang=js&"
export * from "./sysRegister.vue?vue&type=script&lang=js&"
import style0 from "./sysRegister.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports